import React, { useEffect, useState } from "react";
import { getNews } from "../../../api/posts";
import { useParams, Link } from "react-router-dom";

const NewsDetails = () => {
  const { id } = useParams();
  const [news, setNews] = useState(null);

  useEffect(() => {
    const fetchNews = async () => {
      try {
        const data = await getNews(id);
        setNews(data.data);
      } catch (error) {
        console.error("Error fetching news:", error);
      }
    };
    fetchNews();
  }, [id]);

  if (!news) return <div className="p-6 text-center text-gray-500 pt-40">News not found.</div>;

  const formattedDate = new Date(news?.updatedAt).toLocaleString("en-US", {
    month: "long",     // full month name
    day: "numeric",
    year: "numeric",
    hour: "numeric",
    minute: "2-digit",
    hour12: true       // 12-hour format
  })



  return (
    <div className="py-32 px-4 sm:px-8 lg:px-32 min-h-screen">
      <div className="mb-6">
        <Link to="/news" className="text-blue-600 hover:underline text-sm">
          ← Back to all news
        </Link>
      </div>
      <div className="p-6 ">
        <img
          src={news.image}
          alt={news.title}
          className="w-full h-80 sm:h-[500px] object-contain rounded-lg mb-6 bg-white"
        />
        <p className="text-gray-500 text-sm mb-2">{formattedDate}</p>
        <h1 className="text-4xl font-bold text-gray-800 mb-4">{news.title}</h1>
        <p className="text-gray-700 leading-relaxed text-lg">{news.paragraph}</p>
      </div>
    </div>
  );
};

export default NewsDetails;
